class EditorialFeatures extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
  }

  initSwiper() {
    let swiperContainer = this.querySelector(".editorial-swiper");
    if (!this.querySelector(".splide")) return;

    const recalculateArrows = () => {
      swiperContainer.querySelectorAll(".splide__arrow").forEach((element) => {
        const style = window.getComputedStyle(element);
        if (
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          element.offsetParent !== null
        ) {
          let arrowHeight = element.offsetHeight;
          let pictureHeight =
            swiperContainer.querySelector("img")?.offsetHeight || 0;
          let marginAdjustment = (pictureHeight - arrowHeight / 2) / 2;
          swiperContainer
            .querySelectorAll(".splide__arrow")
            .forEach((element) => {
              element.style.top = marginAdjustment + "px";
            });
        }
      });
    };

    this.slider = new window.app.Splide(this.querySelector(".splide"), {
      autoWidth: true,
      gap: 20,
      pagination: false,
      focus: 0,
      omitEnd: true,
      breakpoints: {
        767: {
          gap: 12,
        },
      },
    });

    this.slider.on("mounted", function () {
      recalculateArrows();
    });

    this.slider.on("resize", function () {
      recalculateArrows();
    });

    this.slider.mount();
  }
}

customElements.define("editorial-features", EditorialFeatures);
